import { gql } from '@apollo/client'

export const EventMutations = {
  EVENT: gql`
    mutation Event($input: [EventInput!]!) {
      event(input: $input)
    }
  `,
}
